// #ux-redesign-start: sanitización de HTML para mensajes WYSIWYG.
// Defensa en profundidad: el WYSIWYG (Quill) ya limita por toolbar, pero
// alguien podría pegar HTML arbitrario o el body podría venir corrupto.
// DOMPurify es estándar industrial.
//
// Reglas:
//   - Permitir solo tags de formato basico (b, i, u, strong, em, p, br, ul, ol, li, a).
//   - Permitir solo href en <a>, con target=_blank + rel=noopener forzados.
//   - Bloquear todos los event handlers, javascript:, data:, etc.
// ─────────────────────────────────────────────────────────────────────────────
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'span', 'div',
  'b', 'strong', 'i', 'em', 'u',
  'ol', 'ul', 'li',
  'a',
  'blockquote',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'class'];

// Forzar target=_blank + rel=noopener en links (seguridad ante tabnabbing).
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node && node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export const sanitizeMessageHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    USE_PROFILES: { html: true },
  });
};

// Strip HTML para el preview en la lista de mensajes.
export const stripHtml = (html) => {
  if (!html) return '';
  // Sanitizamos primero (por si tiene XSS) y despues sacamos todos los tags.
  const safe = DOMPurify.sanitize(String(html), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
  return safe.replace(/\s+/g, ' ').trim();
};

export default sanitizeMessageHtml;
// #ux-redesign-end
